import { memo } from "react";
import { IExtendedSearchData, IExtendedSearchProps } from "src/api/server/extended-search.types";
import { useIsNewSearchPageVisit } from "src/components/pages/search/hooks/use-is-new-search-page-visit";
import { useSearchUrlSync } from "src/components/pages/search/hooks/use-search-url-sync";
import { SearchPageContent } from "src/components/pages/search/search-content";
import { TViewMode, setSearchStateSilently } from "src/components/pages/search/store/search-store";
import { getDefaultSearchRanking } from "src/components/pages/search/utils/get-default-ranking";
import { IInitialSorting } from "src/components/pages/search/utils/get-initial-sorting-from-query";
import { TagTooltipsProvider } from "src/components-mui/base/table-scrollable/components/entity/tag-tooltips-context";

interface ISearchPageProps extends IExtendedSearchProps {
    readonly initialView: TViewMode;
    readonly initialSorting: IInitialSorting;
    readonly initialSearchTerm: string;
}

interface ISearchStoreSyncProps {
    readonly data: IExtendedSearchData;
    readonly initialView: TViewMode;
    readonly initialSorting: IInitialSorting;
    readonly initialSearchTerm: string;
}

const SearchStoreSync = ({ data, initialView, initialSorting, initialSearchTerm }: ISearchStoreSyncProps) => {
    if (useIsNewSearchPageVisit(data)) {
        setSearchStateSilently(current => ({
            ...current,
            view: initialView,
            selectedRanking: initialSorting.selectedRanking,
            sortDirection: initialSorting.sortDirection,
            query: initialSearchTerm,
        }));
    }

    useSearchUrlSync({ data, ranking: getDefaultSearchRanking(data) });

    return null;
};

function Page({ data, initialView, initialSorting, initialSearchTerm }: Readonly<ISearchPageProps>) {
    return (
        <>
            <SearchStoreSync data={data} initialView={initialView} initialSorting={initialSorting} initialSearchTerm={initialSearchTerm} />
            <TagTooltipsProvider tagsWithTooltips={data.tagsWithTooltips}>
                <SearchPageContent data={data} />
            </TagTooltipsProvider>
        </>
    );
}

export default memo(Page);
